import { __awaiter, __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation, } from '@angular/core';
import { SharedHttp } from '../../../../services/http-client.service';
import { AuthService } from '../../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../../../services/payment.service';
import { SpinnerService } from '../../../spinner/spinner.service';
import { WebClientService } from '../../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilityService } from '../../../../services/utility.service';
import { LimitExceededModalComponent } from "../../../limit-exceeded-modal/limit-exceeded-modal.component";
import { ComponentService } from "../../../../services/component.service";
import { DepositOriginService } from '../../../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../../../services/deposit-origin';
import { CheckProtocolModalComponent } from "../../../check-protocol-modal/check-protocol-modal.component";
/**
 * Home Component
 */
let BuyComponent = class BuyComponent {
    constructor(httpClient, route, router, auth, paymentService, spinner, webSettingsService, sanitizer, themeService, utility, compService, depositOriginService) {
        this.httpClient = httpClient;
        this.route = route;
        this.router = router;
        this.auth = auth;
        this.paymentService = paymentService;
        this.spinner = spinner;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.utility = utility;
        this.compService = compService;
        this.depositOriginService = depositOriginService;
        this.buyData = {};
        this.draftData = {};
        this.cryptoAccounts = [];
        this.saveAddress = '';
        this.userData = {};
        this.status = 'registred_user';
        this.orderMessage = '';
        this.resultOfService = [];
        this.buyFeesLimits = {};
        this.personalValidationRequired = false;
        this.feesAndLimitsLoaded = false;
        this.orderState = '';
        this.sentEmailMessage = false;
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.limitValue = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.mainColor = '';
        this.linkColor = '';
        this.secondColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.tabColor = '';
        this.accentColor = '';
        this.orderType = 'buy';
        this.clicked = false;
        this.errorInForm = false;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.isIndividual = 1;
        this.targetUrl = '';
        this.ecurrencyChains = [];
        this.someoneElsesAddressError = false;
        this.orderAlreadyCreatedError = false;
        this.priceLoaded = false;
        this.priceNotLoadedMessage = false;
        this.userValidated = false;
        this.spinner.start();
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.buyData = this.userData;
        this.buyData.address = this.userData.city;
        this.userType = this.userData.user_type_id.type;
        this.status = this.userType + '_user';
        this.isIndividual = this.userData.is_company_user ? 0 : 1;
        this.userValidated = this.userData.validated;
        if (this.userData.personal_validation_required === 1) {
            this.personalValidationRequired = true;
        }
        if (localStorage.getItem('draftData')) {
            this.buyData = JSON.parse(localStorage.getItem('draftData'));
            this.buyData.address = JSON.parse(localStorage.getItem('draftData')).place;
        }
        this.route.params.subscribe((params) => {
            this.nameOfCurrency = params.id;
            this.currentMeanOfPayment = params.mp;
            this.httpClient.get('user/getcryptoaddresses/' + this.nameOfCurrency).subscribe((result) => {
                this.cryptoAccounts = result;
            });
        });
        this.paymentService.getMeansOfPayment().subscribe((requestData) => {
            this.resultOfService = JSON.parse(requestData._body);
            if (this.resultOfService.length === 1) {
                this.currentMeanOfPayment = this.resultOfService[0].verbose_id;
            }
        }, (error) => {
            this.spinner.stop();
            console.error(error);
        });
        this.setActive(this.currentMeanOfPayment);
        this.targetUrl = this.router.url;
        if (this.targetUrl.startsWith('/buy')) {
            if (this.userData.risk_level === 'High') {
                this.httpClient.get('market/order/questionnaireFilled?risk_level=' + this.userData.risk_level).subscribe((data) => {
                    if (!data['isQuestionnaireFilled']) {
                        localStorage.setItem('riskLevel', this.userData.risk_level);
                        localStorage.setItem("questionnaireSubmitted", "false");
                        this.router.navigateByUrl('/questionnaire');
                    }
                });
            }
        }
        this.getPrice();
        setTimeout(() => {
            this.priceNotLoadedMessage = true;
        }, 3000);
    }
    ngOnInit() {
        let scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else {
                clearInterval(scrollInterval);
            }
        }, 15);
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.orderForm !== 'undefined') {
                const data = this.orderForm.getData();
                if (typeof this.provision === 'undefined') {
                    this.provision = data.provision;
                }
                this.orderForm.validateTotalAndAmount();
                yield this.orderForm.validateAddress();
                yield this.orderForm.verifyDiscount();
                if (!data.ecurrencyChain && data.chainMandatory)
                    this.orderForm.chainError = true;
                this.errorInForm = !this.orderForm.validateTotalAndAmount() || !(yield this.orderForm.validateAddress()) || this.orderForm.couponError || this.orderForm.chainError || this.orderForm.someoneElsesAddresses.includes(data.deposit_address);
                if (!this.errorInForm) {
                    this.buyData.cryptocurrency = this.nameOfCurrency;
                    this.buyData.mean_of_payment = this.currentMeanOfPayment;
                    this.buyData.total = data.total;
                    this.buyData.amount = data.amount;
                    this.buyData.deposit_address = data.deposit_address;
                    this.buyData.discount_code = data.discount_code;
                    this.buyData.fixed_fee = data.fixedFee;
                    this.buyData.chain = data.ecurrencyChain['chain']['name'];
                    this.saveAddress = data.saveAddress;
                    this.whatLast = this.orderForm.whatLast;
                    this.someoneElsesAddressError = false;
                    if (this.ecurrencyChains.length > 1) {
                        this.maxAmount = data.maxAmount;
                        this.minAmount = data.minAmount;
                    }
                    if (this.buyData.total <= this.maxAmount && this.buyData.total >= this.minAmount && (yield this.orderForm.validateAddress())) {
                        if (this.whatLast === 'amount') {
                            delete this.buyData.total;
                        }
                        if (this.whatLast === 'total') {
                            delete this.buyData.amount;
                        }
                        if (this.validateEmail(this.buyData.email)) {
                            if (this.orderForm.shouldSaveMethod()) {
                                this.buyData.remember = 1;
                                this.buyData.account_name = this.saveAddress;
                            }
                            if (this.ecurrencyChains.length > 1) {
                                this.compService.openModal(CheckProtocolModalComponent, {
                                    selectedChain: data.ecurrencyChain,
                                }, (success) => {
                                    this.createBuyOrder();
                                }, (error) => {
                                    this.clicked = false;
                                });
                            }
                            else {
                                this.createBuyOrder();
                            }
                        }
                    }
                }
            }
        });
    }
    send_email_again() {
        if (!this.utility.disabledFromTimer) {
            this.confirmationMessage = '';
            this.confirmationMessageError = '';
            this.utility.goDisableSendSmsButton();
            this.httpClient.post('market/order/draft/requestconfirm', { id: this.draftData.order_id }).subscribe((success) => {
                this.confirmationMessage = success['message'];
            }, (error) => {
                this.confirmationMessageError = error.error.message;
                this.utility.resetTimer();
            });
        }
    }
    validateEmail(email) {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(email) === false) {
            return false;
        }
        return true;
    }
    setActive(id) {
        this.clicked = false;
        if (this.activeMeanOfPayment !== id) {
            this.provision = null;
            this.fixedFee = null;
            this.orderMessage = '';
            this.activeMeanOfPayment = id;
            this.currentMeanOfPayment = id;
            this.httpClient.get('user/isorderallowed?cryptocurrency=' + this.nameOfCurrency + '&txtype=buy&mop=' + this.currentMeanOfPayment).subscribe((result) => {
                this.orderMessage = result + '';
                if (this.orderMessage === 'INVALID_MEAN_OF_PAYMENT') {
                    let deleteId = null;
                    for (let i = 0; i < this.resultOfService.length; i++) {
                        this.resultOfService[i].disabled_mop = this.buyFeesLimits.buy[this.nameOfCurrency][this.resultOfService[i].verbose_id][this.userType].disabled;
                        if (this.resultOfService[i].verbose_id === this.currentMeanOfPayment) {
                            deleteId = i;
                            break;
                        }
                    }
                    if (deleteId !== null) {
                        this.resultOfService.splice(deleteId, 1);
                    }
                    if (this.resultOfService.length > 0) {
                        this.currentMeanOfPayment = this.resultOfService[0].verbose_id;
                        this.setActive(this.currentMeanOfPayment);
                    }
                }
                this.spinner.stop();
            }, (error) => {
                console.error(error);
                this.spinner.stop();
            });
            this.httpClient.get('market/order/get_ecurrency_chains?currency=' + this.nameOfCurrency + '&order_type=' + this.orderType + '&mean_of_payment=' + this.currentMeanOfPayment).subscribe((result) => {
                this.ecurrencyChains = result['chains'];
                this.numOfChains = result['num_of_chains'];
                if (this.ecurrencyChains.length === 1) {
                    this.httpClient.get('market/feesandlimits?is_individual=' + this.isIndividual + '&ecurrency=' + this.nameOfCurrency + '&chain=' + this.ecurrencyChains[0]['chain']['name']).subscribe((data) => {
                        this.buyFeesLimits = data;
                        const feesForCurrency = this.buyFeesLimits.buy[this.nameOfCurrency];
                        if (feesForCurrency !== undefined) {
                            if (this.activeMeanOfPayment in feesForCurrency) {
                                const activeFees = feesForCurrency[this.activeMeanOfPayment][this.userType];
                                this.provision = parseFloat(activeFees.fee);
                                this.minAmount = parseFloat(activeFees.min_amount);
                                this.maxAmount = parseFloat(activeFees.max_amount);
                                this.fixedFee = parseFloat(activeFees.fixed_fee);
                                this.minFee = parseFloat(activeFees.min_fee);
                                if (this.activeMeanOfPayment === 'card') {
                                    this.orderPaymentTime = parseInt(activeFees.order_payment_time);
                                }
                            }
                            for (let i = 0; i < this.resultOfService.length; i++) {
                                if (this.resultOfService[i].verbose_id in feesForCurrency) {
                                    this.resultOfService[i].disabled_mop = feesForCurrency[this.resultOfService[i].verbose_id][this.userType].disabled;
                                }
                                else {
                                    this.resultOfService[i].disabled_mop = true;
                                }
                            }
                            this.spinner.stop();
                        }
                        this.feesAndLimitsLoaded = true;
                    });
                }
                else {
                    this.feesAndLimitsLoaded = true;
                }
            }, (error) => {
                this.orderMessage = 'CURRENCY_ORDER_TYPE_DISABLED';
            });
        }
    }
    createBuyOrder() {
        this.httpClient.post('market/order/draft/registred/buy', this.buyData).subscribe((draftData) => {
            this.draftData = draftData;
            localStorage.setItem('draftData', JSON.stringify(this.draftData));
            localStorage.setItem('currentOrderMeanOfPayment', JSON.stringify(this.draftData.mean_of_payment));
            localStorage.setItem('orderId', this.draftData.order_id);
            this.orderState = this.draftData.order_state;
            if (draftData['status'] === 'Čekanje na dokumentaciju') {
                this.httpClient.post('market/order/sendL2LimitInstructions', { order_id: this.draftData.order_id }).subscribe();
                this.router.navigateByUrl('/documentation/' + draftData['order_id']);
            }
            else {
                if (this.orderState === 'confirmed') {
                    this.router.navigateByUrl('/buy/confirm/' + this.draftData.order_id);
                }
                else if (this.orderState === 'unconfirmed') {
                    this.sentEmailMessage = true;
                }
            }
        }, (error) => {
            this.orderMessage = error.error.message;
            if (this.orderMessage === 'ORDER_ALREADY_CREATED') {
                this.orderAlreadyCreatedError = true;
                setTimeout(() => {
                    this.clicked = false;
                    this.orderAlreadyCreatedError = false;
                }, 30000);
            }
            else {
                this.clicked = false;
            }
            if (this.orderMessage === 'ADDRESS_USED_BY_ANOTHER_USER') {
                this.someoneElsesAddressError = true;
            }
            if (this.orderMessage === 'USER_WEEKLY_LIMIT_EXCEEDED') {
                this.httpClient.get('market/order/questionnaireValidated?order_type_name=' + this.orderType).subscribe((data) => {
                    if (!data['isQuestionnaireValidatedThisWeek']) {
                        localStorage.setItem('orderType', this.orderType);
                        localStorage.setItem('orderData', JSON.stringify(this.buyData));
                        localStorage.setItem("questionnaireSubmitted", "false");
                        localStorage.setItem("provision", JSON.stringify(this.provision));
                        this.router.navigateByUrl('/questionnaire');
                    }
                });
            }
            if (isDepositOriginCode(this.orderMessage)) {
                // the deposit trigger wants the statement or the proof of origin: its window over this page
                this.depositOriginService.openForCode(this.orderMessage);
            }
            if (this.orderMessage === 'USER_WEEKLY_LIMIT_LITE_EXCEEDED' || this.orderMessage === 'USER_MONTHLY_LIMIT_LITE_EXCEEDED' || this.orderMessage === 'USER_YEARLY_LIMIT_LITE_EXCEEDED') {
                this.compService.openModal(LimitExceededModalComponent);
            }
            if (this.orderMessage === 'USER_DAILY_LIMIT_EXCEEDED' ||
                this.orderMessage === 'USER_WEEKLY_LIMIT_EXCEEDED' ||
                this.orderMessage === "USER_WEEKLY_LIMIT_L2_EXCEEDED" ||
                this.orderMessage === 'USER_MONTHLY_LIMIT_EXCEEDED') {
                this.limitValue = error.error.value;
            }
        });
    }
    checkIfFormIsValid() {
        if (typeof this.orderForm !== 'undefined') {
            return !!((this.clicked && !this.errorInForm) || !this.orderForm.txData.amount || !this.orderForm.validTotalAndAmount
                || !this.orderForm.txData.deposit_address || !this.orderForm.validDepositAddress || this.orderForm.couponError
                || this.orderForm.someoneElsesAddresses.includes(this.orderForm.txData.deposit_address));
        }
        else {
            return true;
        }
    }
    showDefaultErrorMessage() {
        const errorMessages = [
            'INVALID_AMOUNT',
            'USER_TOO_MANY_ORDERS',
            'PERSONAL_VERIFICATION_REQUIRED',
            'CURRENCY_ORDER_TYPE_DISABLED',
            'USER_DAILY_LIMIT_EXCEEDED',
            'USER_WEEKLY_LIMIT_EXCEEDED',
            'USER_MONTHLY_LIMIT_EXCEEDED',
            'ORDER_ALLOWED',
            'ORDER_ALREADY_CREATED',
            'ADDRESS_USED_BY_ANOTHER_USER',
            'USER_VERIFICATION_DOCUMENT_EXPIRED_OR_PENDING',
            'DEPOSIT_WEEKLY_LIMIT_EXCEEDED',
            'DEPOSIT_WEEKLY_LIMIT_L2_EXCEEDED',
            ''
        ];
        return !errorMessages.includes(this.orderMessage);
    }
    getPrice() {
        this.httpClient.get('market/price/' + this.nameOfCurrency).subscribe((data) => {
            this.priceLoaded = true;
            this.price = data;
        });
    }
};
BuyComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: Router },
    { type: AuthService },
    { type: PaymentService },
    { type: SpinnerService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: UtilityService },
    { type: ComponentService },
    { type: DepositOriginService }
];
__decorate([
    ViewChild('selectSpecial', { static: true })
], BuyComponent.prototype, "selectSpecial", void 0);
__decorate([
    ViewChild('orderForm')
], BuyComponent.prototype, "orderForm", void 0);
__decorate([
    ViewChild('sideMenuFee')
], BuyComponent.prototype, "sideMenuFee", void 0);
BuyComponent = __decorate([
    Component({
        selector: 'ecd-buy-component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./buy.component.html")).default
    })
], BuyComponent);
export { BuyComponent };
